import { observer } from "mobx-react";
import { useEstimateStructure, useVisibilityModeCellClassName, ValueCell } from "@tools";

export const HoursCell = observer((cellProps) => {
  const structure = useEstimateStructure();
  const { hideSummaryHours } = structure.visibility;
  const className = useVisibilityModeCellClassName(hideSummaryHours);
  
  return <ValueCell size="large" className={className} { ...cellProps} />;
})